<template>
  <ul
    class="list-none font-normal"
    :class="{ 'ml-4': level > 0 }"
  >
    <li
      v-for="item in items"
      :key="item.value"
      :class="{ 'font-bold': item.isRefined }"
    >
      <a
        href="#"
        class="block leading-normal"
        @click.prevent="handleClick(item)"
      >
        <span class="inline-block w-[70%] text-EXPONDO-grey">{{ item.label }}</span>
        <span
          class="float-right px-1.5 py-px rounded text-xs"
          :class="item.isRefined
            ? 'bg-EXPONDO-primary-80 text-EXPONDO-white'
            : 'bg-EXPONDO-grey-5 text-EXPONDO-grey'"
        >{{ item.count }}</span>
      </a>
      <CustomHierarchicalMenuList
        v-if="item.data && item.data.length > 0"
        :items="item.data"
        :level="level + 1"
        :refine="refine"
      />
    </li>
  </ul>
</template>

<script>


import { EVENT_SOURCE, FILTERS_INTERACTIONS } from '~~/constants/googleTagManager';

export default {
  name: 'CustomHierarchicalMenuList',
  props: {
    items: {
      type: Array,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
    refine: {
      type: Function,
      required: true,
    },
  },
  setup(props) {

    const { callClickFilterEvent } = useClickFiltersEvent();

    const handleClick = (item) => {

      const filterInteraction =
        item.isRefined ? FILTERS_INTERACTIONS.FILTER_UNSELECT : FILTERS_INTERACTIONS.FILTER_SELECT;

      callClickFilterEvent({
        filterInteraction,
        filterSection: EVENT_SOURCE.HIERARCHICAL_TREE,
        filterName: item.label,
        filterValue: item.value,
      });

      props.refine(item.value);
    
    };

    return {
      handleClick,
    };
  
  },
};

</script>
